import { backButton, mainButton, miniApp, useSignal, viewport } from '@telegram-apps/sdk-react'
import { useEffect } from 'react'

export function useIsDark(): boolean {
  return useSignal(miniApp.isDark)
}

export function useViewportHeight(): number {
  return useSignal(viewport.stableHeight)
}

export function useIsMainButtonVisible(): boolean {
  return useSignal(mainButton.isVisible)
}

export function useBackButton(onBack: (() => void) | undefined): void {
  useEffect(() => {
    if (!onBack) {
      backButton.hide.ifAvailable()

      return
    }

    backButton.show.ifAvailable()

    const [subscribed, off] = backButton.onClick.ifAvailable(onBack)

    return () => {
      if (subscribed) {
        off()
      }

      backButton.hide.ifAvailable()
    }
  }, [onBack])
}

export interface MainButtonOptions {
  text: string
  onClick: () => void
  enabled?: boolean
  loading?: boolean
}

export function useMainButton(options: MainButtonOptions | undefined): void {
  const text = options?.text
  const enabled = options?.enabled ?? true
  const loading = options?.loading ?? false
  const onClick = options?.onClick

  useEffect(() => {
    if (!text || !onClick) {
      mainButton.setParams.ifAvailable({ isVisible: false })

      return
    }

    mainButton.setParams.ifAvailable({
      text,
      isVisible: true,
      isEnabled: enabled,
      isLoaderVisible: loading,
    })

    const [subscribed, off] = mainButton.onClick.ifAvailable(onClick)

    return () => {
      if (subscribed) {
        off()
      }

      mainButton.setParams.ifAvailable({ isVisible: false })
    }
  }, [text, enabled, loading, onClick])
}
